import { render } from "./userList-menu.vue?vue&type=template&id=79471b46&scoped=true"
import script from "./userList-menu.vue?vue&type=script&lang=js"
export * from "./userList-menu.vue?vue&type=script&lang=js"

import "./userList-menu.vue?vue&type=style&index=0&id=79471b46&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79471b46"]])

export default __exports__